module.exports = "/packs/images/svg/ireland/facilities/spa~c041096423937c1ba96c155aa84c9af7.svg";